<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdToolsRelateOperationResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      header-btn-add-disabled
                                      :custom-form-class="customFormClass"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button-group>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="收到"
                                            :disabled="$_notChecked"
                                            :busy="statusChangeLoading"
                                            show-name
                                            confirm-text="确认收到吗？"
                                            @click="changeStatus('false')"
                                        ></em-button>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="还回"
                                            :disabled="$_notChecked"
                                            :busy="statusChangeLoading"
                                            show-name
                                            confirm-text="确认还回吗？"
                                            @click="changeStatus('true')"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2022-01-20 09:44:08

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesPrdToolsRelateOperationListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        customFormClass() {
            return (col, row) => {
                if (col.key === 'operationSeq') {
                    if (this.conflictIds.some(o => row.id === o)) {
                        return "bg-danger text-white";
                    }
                }
                return "";
            };
        }
    },
    data() {
        return {
            statusChangeLoading: false,
            conflictIds: []
        }
    },
    mounted() {
        this.searchConflict();
    },
    methods: {
        changeStatus(isReturn) {
            if (!this.$_notChecked && isReturn !== undefined) {
                this.statusChangeLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdToolsRelateOperation/changeStatus?ids=${this.selectIds}&isReturn=${isReturn}`,
                    data: {}
                }).then(() => {
                    this.$message.success("操作成功");
                    this.$refs.emListFilter.doQuery();
                }).finally(() => this.statusChangeLoading = false);
            }
        },
        searchConflict() {
            let toolsId = this.$store.state.routeStore.content.toolsId;
            if (toolsId) {
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdToolsRelateOperation/conflict/search?toolsId=${toolsId}`
                }).then(response => {
                    this.conflictIds = response;
                });
            }
        }
    }
};
</script>